import React from "react";
import styles from "./styles.module.css";
const NoHistory = () => {
  return (
    <div className={styles["no-history-container"]}>
      No history records to show
    </div>
  );
};

export default NoHistory;
